import { render, staticRenderFns } from "./reporttipsbodegasbbcdetail.vue?vue&type=template&id=7c242a60"
import script from "./reporttipsbodegasbbcdetail.vue?vue&type=script&lang=js"
export * from "./reporttipsbodegasbbcdetail.vue?vue&type=script&lang=js"
import style0 from "./reporttipsbodegasbbcdetail.vue?vue&type=style&index=0&id=7c242a60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports